import React, { Component,Fragment } from "react";
import "./aboutUs.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";

export default class aboutUs extends Component {

    render() {
        return (
            <Fragment>
                <Header />
                <section className="container about">
                    <div className="row">
                        <figure className="figure">
                            <div className="img-abouecomany">
                                <img src={require('../../assets/images/havayar/havayarBlack.jpg')} className="figure-img img-fluid " alt="..." />
                            </div>
                            <figcaption className="figure-caption about-info">
                                <h1>آینده نیازمند نوآوری است</h1>
                                <p className="lead">
                                    هوایار به عنوان یکی از بزرگ‌ترین و برترین تولید کننده‌ها و تأمین کننـده‌های تجهیـزات هوای فشرده مطابق بــا آخرین تکنولوژی روز دنیا، از تیر ماه ۱۳۷۷ به منظور تولید کمپرسورهای صنعتی و تجهیزات جانبی هوای فشرده فعالیت خود را آغاز نمود و هوایار با بهره‌مندی از مدیریت متعهد و کارآمد، اتکاء به تجربیات سالیان حضور خود در صنعت و کادر فنی قوی خود توانسته سطح کیفی محصولات خود را به بالاترین درجه ممکن برساند.
                                </p>
                            </figcaption>
                        </figure>
                    </div>
                </section>
                <div className="gray-box">
                    <h3>مدیر عامل</h3>
                    <img className="img-fluid" src={require('../../assets/images/general/kindpng_4551184.png')} alt=""/>
                </div>
                <section className="container">
                    <div className="row aboutRow hrow">
                        <h4 className="ha_title">
                            راه‌های ارتباطی با هوایار
                        </h4>

                        <dl className="row">
                            <dt className="col-sm-3">آدرس:</dt>
                            <dd className="col-sm-9">ایران، تهران، خیابان ولیعصر، نرسیده به میدان ونک، خیابان ۱۴ (گاندی) پلاک ۱۲، ساختمان هوایار</dd>
                            <dt className="col-sm-3">ایمیل:</dt>
                            <dd className="col-sm-9">info@havayar.com</dd>
                            <dt className="col-sm-3">تلفن:</dt>
                            <dd className="col-sm-9"><a href="tel:021-88202424" className="tellink">تلفن : ۴۱۹۷۶(۰۲۱)</a></dd>
                        </dl>
                    </div>
                </section>
                <Footer />
            </Fragment>
        );
    }
}
